import styled from "styled-components";

const Footer = styled.div`
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  padding: 20px 0;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.1);
`;

export default Footer;
